<template>
  <div class="result">
    <div class="back" @click="$router.push('/course')">
      <van-icon name="arrow-up" size="24" />
      <div>查看院系课表</div>
    </div>

    <div class="img-wrapper">
      <img src="@/assets/img/result.png" alt="" class="bg">

      <div class="public first">
        <p><span>{{num1}}</span>的同学和你的课程非常相像</p>
        <p>也就是说，每<span>{{num2}}</span>个人当中就有一人和你的课表一样</p>
      </div>

      <div class="public tag tag1">{{tag1}}</div>

      <div class="public tag tag2">{{tag2}}</div>

      <div class="public second">
        <p>有 <span>{{num3}}</span> 的同学都和你一样选修了<span>{{tag3}}</span></p>
        <p>其中<span>{{tag4}}</span>是<span>{{zy}}</span>中一门很容易挂科的科目，挂科率达到<span>{{num4}}</span>，但学成之后，也会对提升自己有很大帮助。</p>
      </div>

      <div :class="sameCourse[0].length <=7 ? 'line' :''" class="item same1">{{sameCourse[0]}}</div>
      <div :class="sameCourse[1].length <=7 ? 'line' :''" class="item same2">{{sameCourse[1]}}</div>
      <div :class="sameCourse[2].length <=7 ? 'line' :''" class="item same3">{{sameCourse[2]}}</div>
      <div :class="otherCourse[0].length<=7 ? 'line' :''" class="item other1">{{otherCourse[0]}}</div>
      <div :class="otherCourse[1].length<=7 ? 'line' :''" class="item other2">{{otherCourse[1]}}</div>
      <div :class="otherCourse[2].length<=7 ? 'line' :''" class="item other3">{{otherCourse[2]}}</div>
    </div>

    <div class="share" @click="handle">{{$route.query.sourceId ? '生成我的课表' : '分享我的课表'}}</div>

    <van-overlay :show="show" @click="show = false" z-index='99'>
      <div class="wrapper" @click.stop>
        <img src="@/assets/img/share.png" alt="">
      </div>
    </van-overlay>
  </div>
</template>

<script>
import useSuperSdk from '@/assets/js/useSuperSdk.js'

export default {
  data() {
    return {
      show: false,
      zy: localStorage.getItem('faculty'),
      num1: localStorage.getItem('num1'),
      num2: localStorage.getItem('num2'),
      num3: localStorage.getItem('num3'),
      num4: localStorage.getItem('num4'),
      tag1: localStorage.getItem('tag1'),
      tag2: localStorage.getItem('tag2'),
      tag3: localStorage.getItem('tag3'),
      tag4: localStorage.getItem('tag4'),
      sameCourse: JSON.parse(localStorage.getItem('sameCourse')),
      otherCourse: JSON.parse(localStorage.getItem('otherCourse')),
    }
  },
  computed: {
    slh() {
      return function (str) {
        if (str.length > 6) {
          // console.log(str)
          // console.log(str.split('').splice(0,6))
          return str.split('').splice(0, 6).join('') + '...'
        } else {
          return str
        }
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.wxsetShare()
    }, 1000)
  },
  methods: {
    wxsetShare() {
      const { setShare } = useSuperSdk()

      const school = localStorage.getItem('school')

      const faculty = localStorage.getItem('faculty')

      const sourceId = localStorage.getItem('sourceId')

      const title = `看！这是我在${school}大学${faculty}院系的课表！~`

      const link = `https://a.super.cn/generatingTimetable/#/?sourceId=${sourceId}`

      const desc = '一键了解以后要上什么课，安利你也来玩！'

      setShare(title, link, desc)

      console.log('result页面分享配置')
    },
    handle() {
      if (this.$route.query.sourceId) {
        this.$router.push('/')
      } else {
        this.show = true
        _hmt && _hmt.push(['_trackEvent', 'create-Class', 'creatShare'])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.result {
  .back {
    color: #007aff;
    // font-weight: bold;
    font-size: 14px;
    // position: fixed;
    // top: 10px;
    // z-index: 55;
    // left: 50%;
    // transform: translateX(-50%);
    img {
      width: 30px;
      transform: rotate(180deg);
    }
  }
  .course-table {
    display: flex;
    .section-column {
      display: flex;
      flex-direction: column;
      width: 30px;
      background-color: #f5fcff;
      color: #a1b5c6;
      .fisrt-part {
        position: relative;
        height: 32px;
        // border-bottom: 1px solid #A1B5C6;
      }
      .fisrt-part:after {
        content: ' ';
        position: absolute;
        bottom: 0;
        right: 0;
        height: 1px;
        border-bottom: 1px solid #a1b5c6;
        color: #a1b5c6;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        left: 0;
        z-index: 2;
      }
      .number {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 50px;
        position: relative;
      }
      .number:after {
        content: attr(con);
        position: absolute;
        left: 0;
        top: 0;
        width: 199%; //注意这个宽度，不要为200%，不然会出现有的边框边缘显示不全问题
        height: 200%;
        // background-color: #FFFFFF;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        color: #a1b5c6;
        text-align: center;
        // border-bottom: 1px solid #A1B5C6;
        // border-left: 1px solid #A1B5C6;
        border-right: 1px solid #a1b5c6;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        -webkit-transform: scale(0.5, 0.5);
        transform: scale(0.5, 0.5);
        font-size: 0.24rem;
      }
      .number:last-child:after {
        border-bottom: 1px solid #a1b5c6;
      }
    }
    .day-column {
      // width: 64px;
      flex: 1px;
      .day-title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #f5fcff;
        height: 32px;
        position: relative;
        // opacity: 0.8;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #666666;
      }
      .day-title:after {
        content: ' ';
        position: absolute;
        bottom: 0px;
        right: 0;
        height: 1px;
        border-bottom: 1px solid #a1b5c6;
        color: #a1b5c6;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        left: 0;
        z-index: 2;
      }
      .course-class {
        height: 50px;
        position: relative;
        display: flex;
        justify-content: center;
        span {
          display: flex;
          position: relative;
          z-index: 1;
          align-items: center;
          width: 50px;
          word-break: break-all;
          justify-content: center;
          // height: 65px;
          // letter-spacing: 0;
          // overflow: hidden;
          // display: -webkit-box;
          // text-overflow: ellipsis;
          // -webkit-line-clamp: 4;  /*要显示的行数*/
          // -webkit-box-orient: vertical;
          font-size: 12px;
          // height: 200px;
        }
      }
      .course-class:after {
        content: attr(con);
        position: absolute;
        left: 0;
        top: 0;
        width: 196%; //注意这个宽度，不要为200%，不然会出现有的边框边缘显示不全问题
        height: 198%;
        background-color: #ffffff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        color: #a1b5c6;
        font-size: 0.2rem;
        text-align: center;
        border-bottom: 1px solid #a1b5c6;
        // border-left: 1px solid #A1B5C6;
        border-right: 1px solid #a1b5c6;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        -webkit-transform: scale(0.5, 0.5);
        transform: scale(0.5, 0.5);
        font-size: 0.24rem;
      }
      .course-class-one:after {
        // margin-right: 2px;
        top: 1px;
        // left:1px;
        // right:1px;
        height: 200%;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      .course-class-top:after {
        // margin-right: 2px;
        top: 1px;
        // left:1px;
        // right:1px;
        height: 200%;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
      .course-class-middle:after {
        // left:1px;
        height: 210%;
        right: 1px;
      }
      .course-class-bottom:after {
        bottom: 1px;
        // left:1px;
        height: 200%;
        right: 1px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      .course-blue {
        font-family: PingFangSC-Medium;
        font-size: 11px;
        color: #45a1f4;
      }
      .course-blue:after {
        // opacity: 0.85;
        background-color: #e4f3fe;
      }
      .course-green {
        font-family: PingFangSC-Medium;
        font-size: 11px;
        color: #3eb8cf;
      }
      .course-green:after {
        // opacity: 0.85;
        background: #defbf7;
      }
      .course-green {
        font-family: PingFangSC-Medium;
        font-size: 11px;
        color: #3eb8cf;
      }
      .course-green:after {
        // opacity: 0.85;
        background: #defbf7;
      }
      .course-pink {
        font-family: PingFangSC-Medium;
        font-size: 11px;
        color: #ff7d9c;
      }
      .course-pink:after {
        // opacity: 0.85;
        background: #ffeef0;
      }
      .course-yellow {
        font-family: PingFangSC-Medium;
        font-size: 11px;
        color: #fb814d;
      }
      .course-yellow:after {
        // opacity: 0.85;
        background: #ffeadc;
      }
    }
  }
  .img-wrapper {
    width: 100%;
    position: relative;
    text-align: left;
    .bg {
      width: 100%;
      position: relative;
    }
    .public {
      position: absolute;
      z-index: 2;
      color: #000;
      letter-spacing: 2px;
      p {
        span {
          font-size: 22px;
          font-weight: bold;
        }
      }
    }

    .tag {
      font-size: 22px;
      font-weight: bold;
    }

    .first {
      top: 110px;
      left: 28px;
    }

    .second {
      // width: 370px;
      top: 458px;
      left: 20px;
      line-height: 25px;
      span {
        font-size: 14px !important;
        font-weight: bold;
      }
    }

    // .num1 {
    //   top: 108px;
    //   left: 28px;
    // }
    // .num2 {
    //   top: 134px;
    //   left: 108px;
    // }
    // .num3 {
    //   top: 468px;
    //   left: 50px;
    // }
    // .num4 {
    //   top: 548px;
    //   left: 278px;
    //   color: red;
    //   font-size: 18px;
    //   letter-spacing: 0px;
    // }
    .tag1 {
      top: 270px;
      left: 170px;
    }
    .tag2 {
      top: 354px;
      left: 42px;
    }
    // .tag3 {
    //   top: 498px;
    //   left: 22px;
    //   font-size: 12px;
    //   color: #0f0f0f;
    // }
    // .tag4 {
    //   top: 525px;
    //   left: 50px;
    //   font-size: 16px;
    // }
    // .tag5 {
    //   top: 525px;
    //   right: 30px;
    //   font-size: 16px;
    // }
    .item {
      position: absolute;
      font-size: 14px;
      color: #000;
      width: 105px;
      height: 50px;
      text-align: left;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .line {
      line-height: 50px;
    }
    .same1 {
      bottom: 240px;
      left: 35px;
    }
    .same2 {
      bottom: 240px;
      left: 140px;
    }
    .same3 {
      bottom: 240px;
      left: 248px;
    }
    .other1 {
      bottom: 125px;
      left: 35px;
    }
    .other2 {
      bottom: 125px;
      left: 140px;
    }
    .other3 {
      bottom: 125px;
      left: 246px;
    }
  }
  .share {
    position: fixed;
    bottom: 25px;
    left: 50%;
    transform: translateX(-50%);
    background: #007aff;
    font-size: 15px;
    color: #ffffff;
    letter-spacing: 0.25px;
    text-align: center;
    padding: 10px 25px;
    border: #007aff;
    border-radius: 24px;
    z-index: 3;
  }
  .download {
    width: 100%;
  }
  .wrapper {
    text-align: right;
    img {
      margin-top: 15px;
      margin-right: 25px;
      width: 150px;
    }
  }
}
</style>
